import { clearLS, getLS, removeLS, setLS } from '../utils';

export function setArTable() {
  if (document.querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')) {
    document
      .querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')
      .classList.add('pagination-rtl');
    document
      .querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')
      .classList.remove('pagination-ltr');
  }

  const list = document.querySelectorAll('.react-bs-table .table-bordered tbody tr td');
  for (let i = 0; i < list.length; i++) {
    if (list[i].className === 'react-bs-table-no-data') {
      list[i].classList.remove('ltr');
    } else {
      list[i].classList.remove('ltr');
      list[i].classList.add('rtl');
    }
  }

  if (document.querySelector('.react-bs-table-pagination')) {
    document.querySelector('.react-bs-table-pagination').classList.add('rtl');
    document.querySelector('.react-bs-table-pagination').classList.remove('ltr');
  }
}

export function setEnTable() {
  if (document.querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')) {
    document
      .querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')
      .classList.remove('pagination-rtl');
    document
      .querySelector('ul.react-bootstrap-table-page-btns-ul.pagination')
      .classList.add('pagination-ltr');
  }

  const list = document.querySelectorAll('.react-bs-table .table-bordered tbody tr td');
  for (let i = 0; i < list.length; i++) {
    if (list[i].className === 'react-bs-table-no-data') {
      list[i].classList.remove('rtl');
    } else {
      list[i].classList.add('ltr');
      list[i].classList.remove('rtl');
    }
  }
  if (document.querySelector('.react-bs-table-pagination')) {
    document.querySelector('.react-bs-table-pagination').classList.add('ltr');
    document.querySelector('.react-bs-table-pagination').classList.remove('rtl');
  }
}

export function settingAr(i18n) {
  document.querySelector('html').classList.remove('ltr');
  document.querySelector('html').classList.add('rtl');

  if (document.querySelector('p.text-center.ltr')) {
    document.querySelector('p').classList.remove('ltr');
    // document.querySelector( "p" ).classList.add( "rtl" );
  }

  if (document.querySelector('div.page-header')) {
    document.querySelector('div.page-header').classList.add('header-rtl');
    document.querySelector('div.page-header').classList.remove('header-ltr');
  }
  if (document.querySelector('div.filter.text-filter.form-control')) {
    document.querySelector('div.filter.text-filter.form-control').classList.add('rtl');
    document.querySelector('div.filter.text-filter.form-control').classList.remove('ltr');
  }
  const nav_rtl = document.querySelectorAll('div#navbarSupportedContent');
  if (nav_rtl) {
    for (let i = 0; i < nav_rtl.length; i++) {
      nav_rtl[i].classList.add('rtl');
    }
  }

  if (document.querySelector('div.nav-link-theme')) {
    document.querySelector('div.nav-link-theme').classList.add('nav-link-theme-ar');
  }

  setArTable();
  document.body.dir = i18n.dir('ar');
}

export function settingEn(i18n) {
  const nav_rtl = document.querySelectorAll('div#navbarSupportedContent');
  if (nav_rtl) {
    for (let i = 0; i < nav_rtl.length; i++) {
      nav_rtl[i].classList.remove('rtl');
    }
  }

  if (document.querySelector('html.rtl')) {
    document.querySelector('html').classList.remove('rtl');
    document.querySelector('html').classList.add('ltr');
  }

  if (document.querySelector('p.text-center.rtl')) {
    document.querySelector('p').classList.remove('rtl');
  }

  if (document.querySelector('div.page-header')) {
    document.querySelector('div.page-header').classList.remove('header-rtl');
    document.querySelector('div.page-header').classList.add('header-ltr');
  }
  if (document.querySelector('div.filter.text-filter.form-control')) {
    document.querySelector('div.filter.text-filter.form-control').classList.remove('rtl');
    document.querySelector('div.filter.text-filter.form-control').classList.add('ltr');
  }
  setEnTable();
  document.body.dir = i18n.dir('en');
}

export function settingDark(dark) {
  if (dark == 'true') {
    setLS('backgroundColor', '#1a2c4c !important');
    document.body.style.backgroundColor = getLS('backgroundColor');
    document.body.className = 'body-dark';
  } else {
    setLS('backgroundColor', '#f5f5f2 !important');
    document.body.style.backgroundColor = getLS('backgroundColor');
    document.body.className = null;
  }
}

export function settingDarkTable(dark) {
  if (dark == 'true') {
    // table table-striped table-bordered table-hover table-dark

    const list = document.querySelectorAll('table.table.table-hover.table-bordered');
    for (let i = 0; i < list.length; i++) {
      list[i].classList.add('table-dark');
    }

    const list2 = document.querySelectorAll('table.table-striped.table-bordered.table-hover');
    for (let i2 = 0; i2 < list2.length; i2++) {
      list[i2].classList.add('table-dark');
    }

    const list3 = document.querySelectorAll('table.table-hover.table-bordered');
    for (let i3 = 0; i3 < list3.length; i3++) {
      list[i3].classList.add('table-dark');
    }

    if (document.querySelector('input.number-filter-input.form-control')) {
      document
        .querySelector('input.number-filter-input.form-control')
        .classList.add('form-control-dark');
    }
    // calendar
    if (document.querySelector('div.daterangepicker.dropdown-menu.ltr.show-calendar.opensright')) {
      document
        .querySelector('div.daterangepicker.dropdown-menu.ltr.show-calendar.opensright')
        .classList.add('calendar-dark');
    }

    if (document.querySelector('button.cancelBtn.btn.btn-sm.btn-default')) {
      document
        .querySelector('button.cancelBtn.btn.btn-sm.btn-default')
        .classList.add('btn-calendar-light');
    }

    if (document.querySelector('input.input-mini.form-control.active')) {
      document
        .querySelector('input.input-mini.form-control.active')
        .classList.remove('form-control');
    }
  } else {
    if (document.querySelector('table.table-striped.table-bordered.table-hover.table-dark')) {
      document
        .querySelector('table.table-striped.table-bordered.table-hover')
        .classList.remove('table-dark');
    }

    if (document.querySelector('table.table.table-hover.table-bordered.table-dark')) {
      document
        .querySelector('table.table.table-hover.table-bordered')
        .classList.remove('table-dark');
    }

    if (document.querySelector('table.table-hover.table-bordered.table-dark')) {
      document.querySelector('table.table-hover.table-bordered').classList.remove('table-dark');
    }

    if (document.querySelector('input.number-filter-input.form-control.form-control-dark')) {
      document
        .querySelector('input.number-filter-input.form-control')
        .classList.remove('form-control-dark');
    }

    if (
      document.querySelector(
        'div.daterangepicker.dropdown-menu.ltr.show-calendar.opensright.calendar-dark'
      )
    ) {
      document
        .querySelector('div.daterangepicker.dropdown-menu.ltr.show-calendar.opensright')
        .classList.remove('calendar-dark');
    }

    if (document.querySelector('button.cancelBtn.btn.btn-sm.btn-default.calendar-dark')) {
      document
        .querySelector('button.cancelBtn.btn.btn-sm.btn-default')
        .classList.remove('btn-calendar-light');
    }
  }
}

export function settingDropdown(dark) {
  if (dark == 'true') {
    const list = document.querySelectorAll('filter.text-filter.form-control');
    for (let i = 0; i < list.length; i++) {
      list[i].classList.add('form-control-dark');
    }
  } else if (document.querySelector('filter.text-filter.form-control')) {
    document.querySelector('filter.text-filter.form-control').classList.remove('form-control-dark');
  }
}
